import createStoreWithMiddleware from 'utils/store/createStoreWithMiddleware'

export default createStoreWithMiddleware()
